import React, { createContext, useContext, useState, useEffect } from 'react';
import translations, { detectBrowserLanguage, getTranslation, supportedLanguages } from '../i18n/translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');

  useEffect(() => {
    // Check if user has a saved language preference
    const savedLang = localStorage.getItem('nexi_language');
    if (savedLang && translations[savedLang]) {
      setLanguage(savedLang);
    } else {
      // Detect browser language
      const detectedLang = detectBrowserLanguage();
      setLanguage(detectedLang);
      localStorage.setItem('nexi_language', detectedLang);
    }
  }, []);

  const changeLanguage = (langCode) => {
    if (translations[langCode]) {
      setLanguage(langCode);
      localStorage.setItem('nexi_language', langCode);
    }
  };

  const t = (key) => getTranslation(language, key);

  const value = {
    language,
    changeLanguage,
    t,
    supportedLanguages,
    isRTL: language === 'ar', // Arabic is right-to-left
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
